const toFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getNewestItemRank = (item = {}) => {
  const dateValue =
    item.created_at ||
    item.createdAt ||
    item.updated_at ||
    item.updatedAt;
  const timestamp = Date.parse(dateValue);

  if (Number.isFinite(timestamp)) {
    return timestamp;
  }

  return toFiniteNumber(item.id);
};

export const sortNewestFirst = (items = []) =>
  [...items].sort((a, b) => getNewestItemRank(b) - getNewestItemRank(a));
